export const externalLinks = {
    apiDocs: `https://story3.com/api/v2/apidocs`,
    mailtoSupport: 'mailto:support@story3.com',
    mailtoAgentSupport: 'mailto:agents_support@story3.com',
    freeWebinar:
        'https://learn.selfpublishing.com/ramy-story3-august-20-2024?utm_source=Story3&utm_medium=marketing&utm_campaign=selfpublishing-partnership&utm_content=webinar',
};
